import React, { useEffect } from "react";
import Header from "./Header";
import Main from "./Main";
import MovieCategories from "./MovieCategories";
import Footer from "./Footer";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Browse = () => {
  const { data: user, isAuthChecked } = useSelector((store) => store.user);

  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthChecked && !user) {
      navigate("/");
    }
  }, [isAuthChecked, navigate, user]);

  if (!isAuthChecked) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white">
        <div className="h-14 w-14 border-4 border-neutral-700 border-t-red-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) return null;

  return (
    <div className="bg-black">
      <Header />
      <div className="h-96 lg:min-h-screen">
        <Main />
      </div>
      <MovieCategories />
      <Footer />
    </div>
  );
};

export default Browse;
